import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  signUp: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('signUp');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.signUp.length > 0 ? action.signUp : [];  
  return updateObject(state, {
    signUp: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, signUp:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SIGNUP_START:
      return fetchStart(state);
    case actionTypes.FETCH_SIGNUP_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_SIGNUP_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
